import { render, staticRenderFns } from "./SupAgree.vue?vue&type=template&id=cc42df58&scoped=true&"
import script from "./SupAgree.vue?vue&type=script&lang=js&"
export * from "./SupAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc42df58",
  null
  
)

export default component.exports